import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedInvoices, deleteInvoice, markInvoiceAsPaid } from '../../../services/invoiceService';
import { Invoice } from '../../../types/invoice';
import { getInvoiceColumns } from './InvoiceColumns';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';
//import sharedStyles from '../../SharedPageStyles.module.css';

interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const InvoicesListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [invoiceToDelete, setInvoiceToDelete] = useState<Invoice | null>(null);

  const openDeleteDialog = (invoice: Invoice) => {
    setInvoiceToDelete(invoice);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setInvoiceToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!invoiceToDelete) return;
    const promise = deleteInvoice(invoiceToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف الفاتورة...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف الفاتورة بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف الفاتورة.';
      },
    });
  };

  const handleMarkAsPaid = (invoice: Invoice) => {
    const promise = markInvoiceAsPaid(invoice.id);
    toast.promise(promise, {
        loading: 'جاري تحديث الفاتورة...',
        success: () => {
            refreshData();
            return 'تم تحديد الفاتورة كمدفوعة بنجاح!';
        },
        error: (err) => err.response?.data?.message || 'فشل في تحديث الفاتورة.',
    });
  };

  const columns = useMemo(() => getInvoiceColumns(openDeleteDialog, handleMarkAsPaid), []);

  const { table, isLoading, Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<Invoice>({
    columns,
    fetchData: getPagedInvoices,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة الفواتير</h1>
        <Link to="/admin/invoices/add" className={pageStyles.addButton}>
          <Icon as={FaPlus} style={pageStyles.icon } />
          <span>إضافة فاتورة</span>
        </Link>
      </div>
      <div className={pageStyles.pageContent}>
         <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Invoice> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف الفاتورة رقم "${invoiceToDelete?.id}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default InvoicesListPage;
